/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {useTranslation} from "react-i18next";
import React, { useState} from "react";
import {
    EMPTY_VALUES,
} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {
    chipStatusIconClassColor,
    statusBorderColor,
    statusColor,
    statusFontColor
} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import {REQUEST_DOCUMENTATION_ICON_MODEL} from "../../../../Contractor/Documentation/Model/Model";
import MaterialDispatchCard from "./MaterialDispatchCard";
import MaterialRecordDeliveryModal from "../../Modal/MaterialRecordDeliveryModal";
import {CustomLevelCardStyle} from "../../../../../components/Styles";
import {FILE_MODEL} from "../../../Visitor/Visitor/Model/Model";
import {getMaterialRequestDispatchStatusId} from "../../Model/Model";

const MaterialDispatchListSection = ({ data, setModified, contentTableRef, emptyFields }) => {
    const { t } = useTranslation();
    const statusId = getMaterialRequestDispatchStatusId(data?.dispatchStatusId);
    const IconComponent = REQUEST_DOCUMENTATION_ICON_MODEL[statusId] || (() => null);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    const styles = CustomLevelCardStyle(statusId, false);

    return (
        <>
            <div style={styles.container}>
                <div className='d-flex justify-content-between align-items-center h-72px' style={styles.levelCard}>
                    <p className={"fs-16px ibl-font-w-600"}> {t("materials_for_validate")}</p>

                    { statusId &&
                    <CustomChip
                        variant={'large'}
                        icon={<IconComponent className={`${chipStatusIconClassColor[statusId]}`}/>}
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={t(status[statusId]) || EMPTY_VALUES.DEFAULT}
                        classNameIcon={"w-h-24px"}
                        className={"py-2 px-12px h-40px minh-40px maxh-40px"}
                    />
                    }
                </div>
                <div ref={contentTableRef} className={"overflow-y-auto"}>
                    <div className={"row mt-3"}>
                        { data?.items?.map((item) => {
                            const statusId = item?.itemEvidence ? STATUS_MODEL.DRAFT : STATUS_MODEL.PENDING ;
                            let styles = CustomLevelCardStyle( statusId, false);
                            const file = item?.itemEvidence ? FILE_MODEL.set(item?.itemEvidence) : null;

                            return <>
                                <div className={"col-12 mb-3"}>
                                    <MaterialDispatchCard
                                        t={t}
                                        item={item}
                                        file={file}
                                        statusId={statusId}
                                        setShowModal={setShowModal}
                                        setItemSelected={setItemSelected}
                                        styles={styles}
                                        generalStatusId={data?.dispatchStatusId}
                                        emptyFields={emptyFields}
                                    />
                                </div>
                            </>
                        })}
                    </div>
                </div>
            </div>

            { showModal &&
                <MaterialRecordDeliveryModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    itemSelected={itemSelected}
                    setModified={setModified}
                />
            }

        </>
    );
};

export default MaterialDispatchListSection;
